// Import style root
import '../styles/main.scss';

import Prism from 'prismjs';
import AppContainer from './containers/app.container';

function init () {
  window.app = new AppContainer();
  window.app.init();

  Prism.highlightAll();
}

document.addEventListener('DOMContentLoaded', () => {
  init();
});

